<script>
  import componentEditorMixin from '@/components/ProductComponents/CreateComponents/componentEditorMixin.js'
  export default {
    name: "wheelEditor",
    mixins: [componentEditorMixin],
    data() {
      return {
        directionList: [
          {
            value: 'clockWise',
            name: '顺时针'
          },
          {
            value: 'counterClockWise',
            name: '逆时针'
          }
        ],
        // rotateStateList: [
        // 	{
        // 		value: 'running',
        // 		name: '旋转'
        // 	},
        // 	{
        // 		value: 'paused',
        // 		name: '停止'
        // 	}
        // ],
        formList: [
          'WheelForm',
          // ...
        ],
        ruleList: [

        ]
      }
    },
    computed: {
      specificForms() {
        return (
          <div class="specificForms">
              <el-collapse-item class="specificForm" title="旋转效果选项" name="2">
                <template slot="default">
                  <div class="specificForm">
                    <el-form id="WheelForm" {...{attrs: {model: this.newSettings}}} ref="WheelForm">
                      <el-form-item label="转轮颜色" prop="background" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.background,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"转轮颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.backgroundColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="边框颜色" prop="borderColor" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.borderColor,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"边框颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.borderColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="叶片1颜色" prop="background1" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.background1,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"叶片1颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.leafOneColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="叶片2颜色" prop="background2" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.background2,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"叶片2颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.leafTwoColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="叶片3颜色" prop="background3" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.background3,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"叶片3颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.leafThreeColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="叶片4颜色" prop="background4" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.background4,
                          type: 'color',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"叶片4颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.leafFourColorChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      {/* 旋转速度(s) */}
                      <el-form-item label="旋转速度" prop="animationDuration" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.animationDuration,
                          type: 'input',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"旋转速度",
                          }}}{...{on: {
                            'input': val=>{
                              this.changeAnimationDuration(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="旋转方向" prop="direction" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.animationDirection,
                          type: 'radio',
                          radioList: this.directionList,
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"旋转方向",
                          }}}{...{on: {
                            'input': val=>{
                              this.handleDirectionChange(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                      <el-form-item label="旋转" prop="rotateState" label-position={this.labelPosition}>
                        <editor-field {...{attrs: {
                          value: this.newSettings.rotateState,
                          type: 'switch',
                          varList: this.varList,
                          varJson: this.varJson,
                          showEditButton: true,
                            label:"填充颜色",
                          }}}{...{on: {
                            'input': val=>{
                              this.wheelRotateState(val)
                              this.handleConfirmBtnClick()
                            }
                          }}}>
                        </editor-field>
                      </el-form-item>
                    </el-form>
                  </div>
                </template>
              </el-collapse-item>
          </div>
        )
      }
    },
    methods:{
      wheelState(val,attr){
        this.$set(this.newSettings, attr, val)
      },
      backgroundColorChange(val){
        console.log(val)
        this.styleMergeObj = {
          ...this.styleMergeObj,
          background : val
        }
        this.newSettings.background = val
      },
      borderColorChange(val){
        this.styleMergeObj = {
          ...this.styleMergeObj,
          'border-color' : val
        }
        this.newSettings.borderColor = val
      },
      leafOneColorChange(val){
        console.log(val)
        this.newSettings.background1 = val
      },
      leafTwoColorChange(val){
        this.newSettings.background2 = val
      },
      leafThreeColorChange(val){
        this.newSettings.background3 = val
      },
      leafFourColorChange(val){
        this.newSettings.background4 = val
      },
      changeAnimationDuration(val){
        if(val.varName == undefined){  // 输入数值的尽快设置
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-duration': val + 's'
          }
        }
        this.newSettings.animationDuration = val
      },
      handleDirectionChange(val){
        this.newSettings.animationDirection = val
        if(val == 'clockWise'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-direction': 'normal'
          }
        }
        if(val == 'counterClockWise'){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-direction': 'reverse'
          }
        }
      },
      wheelRotateState(val){
        console.log('效果设置',this.newSettings.rotateState)
        this.newSettings.rotateState = val
        if(val == true){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-play-state': 'running'
          }
          console.log(123,this.styleMergeObj)
        }
        else if(val == false){
          this.styleMergeObj = {
            ...this.styleMergeObj,
            'animation-play-state': 'paused'
          }
        }
      },
    }
  }
</script>

<style>
</style>
